module.exports.expansions = {
  vi: {
    title: 'Bản mở rộng Avalon: Tiên nữ, Excalibur và Thẻ âm mưu',
    description:
      'So sánh bản mở rộng Avalon và tìm hiểu luật: Tiên nữ hồ, Tiên nữ biển, Excalibur và Thẻ âm mưu, kèm liên kết đến từng mô-đun chơi trực tuyến.',
    keywords: ['Bản mở rộng', 'Nội dung bổ sung', 'Mô-đun', 'Luật chơi'],
  },
  pt: {
    title: 'Expansões de Avalon: Damas, Excalibur e Cartas de Enredo',
    description:
      'Compare as expansões de Avalon: Dama do Lago, Dama do Mar, Excalibur e Cartas de Enredo. Regras, combinações e exemplos de cada módulo.',
    keywords: ['Expansões', 'Complementos', 'Módulo', 'Regras'],
  },
  en: {
    title: 'Avalon expansions: Lady, Excalibur and Plot Cards',
    description:
      'Compare Avalon expansions and learn their rules: Lady of the Lake, Lady of the Sea, Excalibur and Plot Cards, with links to each online module.',
    keywords: ['Expansions', 'Addons', 'Module', 'Rules'],
  },
  ru: {
    title: 'Дополнения Авалона: Леди, Экскалибур и карты сюжета',
    description:
      'Сравните дополнения Авалона: Леди Озера, Леди Моря, Экскалибур и карты сюжета. Правила модулей, совместимость и ссылки на подробные примеры.',
    keywords: ['Дополнения', 'Аддоны', 'Модули', 'Правила'],
  },
  'zh-TW': {
    title: '阿瓦隆擴充：湖中仙女、神劍與劇情卡規則',
    description: '比較阿瓦隆四種擴充：湖中仙女、海中仙女、Excalibur神劍和劇情卡。了解各自作用、搭配限制及線上玩法。',
    keywords: ['擴充', '附加組件', '模組', '規則'],
  },
  'zh-CN': {
    title: '阿瓦隆扩展：湖中仙女、神剑与剧情卡规则',
    description: '比较阿瓦隆四种扩展：湖中仙女、海中仙女、Excalibur神剑和剧情卡。了解各自作用、搭配限制及在线玩法。',
    keywords: ['扩展', '附加组件', '模块', '规则'],
  },
  es: {
    title: 'Expansiones de Avalon: Damas, Excalibur y Cartas de Trama',
    description:
      'Compara las expansiones de Avalon: Dama del Lago, Dama del Mar, Excalibur y Cartas de Trama. Reglas, compatibilidad y ejemplos de cada módulo.',
    keywords: ['Expansiones', 'Complementos', 'Módulo', 'Reglas'],
  },
};
